import { LocalDataSource } from "../core";

export class UserLocalDataSource extends LocalDataSource {
  public getToken(): string | undefined {
    return this.getCookie("token");
  }

  public setToken(token: string): void {
    this.setCookie("token", token, 30);
  }

  public deleteToken(): void {
    this.deleteCookie("token");
  }

  public hasToken(): boolean {
    const token = this.getToken();
    return token !== "" && token !== undefined;
  }
}
